import { gql, useQuery, useSubscription } from "@apollo/client";
import { Card, Grid } from "@mui/material";
import PageLayout from "components/LayoutContainers/EmpleadoLayout";
import React, { useEffect, useState } from "react";
import dataPendientes from "./data/dataPendientes";
import DataTable from "components/DataTable";
import dataMenusDiarios from "./data/dataMenusDiarios";
import SinDatos from "components/Carteles/SinDatos";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/CheckBox";

const Cocina = () => {
	const [rows, setRows] = useState([]);
	const [rowsMenu, setRowsMenu] = useState([]);
	const { columns, getRows } = dataPendientes;
	const { columnsMenu, getRowsMenu } = dataMenusDiarios;

	const { data: newData } = useSubscription(
		gql`
      subscription {
        nuevoPedido { id }
      }
    `
	);

	const { data: modifiedData } = useSubscription(
		gql`
      subscription {
        pedidoModificado { id }
      }
    `
	);

	const { data, refetch } = useQuery(
		gql`
      query pendientes {
        pendientes {
          mesa {
            numero
          }
          detalles {
            idPedido
            estado
            cantidad
            comentario
            createdAt
            producto {
              nombre
              seccion
            }
          }
        }
      }
    `,
		{
			fetchPolicy: "network-only",
		}
	);

	const { data: dataMenus, refetch: refetchMenus } = useQuery(
		gql`
      query reservadosHoy {
        reservadosHoy {
          idProducto
          productoNombre
          total
          estado
        }
      }
    `,
		{
			fetchPolicy: "network-only",
		}
	);

	useEffect(() => {
		const updateDetalles = () => {
			let detalles = [];
			if (data?.pendientes) {
				data.pendientes.forEach((pedido) => {
					const mesa = pedido.mesa?.numero || null;
					(pedido?.detalles || []).forEach((detalle) => {
						if (detalle.estado === "PENDIENTE" && detalle.producto.seccion == "Cocina") {
							detalles.push({
								mesa,
								...detalle,
							});
						}
					});
				});
			}
			let orderDetalles = detalles.sort((a, b) => {
				return new Date(a.createdAt) - new Date(b.createdAt);
			});
			setRows(getRows(orderDetalles));
		};
		updateDetalles();
		// const intervalId = setInterval(updateDetalles, 10000);
		// return () => clearInterval(intervalId);
	}, [data, newData, modifiedData]);

	useEffect(() => {
		const updateDetallesMenu = () => {
			let menusDiarios = [];
			if (dataMenus?.reservadosHoy) {
				menusDiarios = Object.values(
					dataMenus?.reservadosHoy.reduce((acc, item) => {
						const productoId = item?.idProducto;

						if (!acc[productoId]) {
							acc[productoId] = { id: productoId, nombre: item.productoNombre, cantidad: Number(item.total || 0) };
						} else {
							acc[productoId].cantidad += Number(item.total || 0);
						}

						return acc;
					}, {})
				);
			}
			setRowsMenu(getRowsMenu(menusDiarios));
		};
		updateDetallesMenu();
		// const intervalId = setInterval(updateDetallesMenu, 10000);
		// return () => clearInterval(intervalId);
	}, [dataMenus, newData, modifiedData]);

  useEffect(() => {
    if (newData || modifiedData) { refetch(); refetchMenus(); }
  }, [newData, modifiedData, refetch, refetchMenus]);

	return (
		<PageLayout background="#f3f3f3">
			<SoftBox display="grid" gridTemplateColumns="1fr" gap={1} alignItems="start">
				<SoftBox display="flex" flexDirection="column" justifyContent="flex-start">
					<SoftBox p={2}>
						<Card
							sx={{
								padding: 1,
								marginBottom: 2,
							}}
						>
							<SoftTypography variant="h6" align="center">
								Pedidos
							</SoftTypography>
						</Card>
						{data?.pendientes?.length > 0 ? (
							<DataTable columns={columns} rows={rows} xl />
						) : (
							<Card>
								<SinDatos
									titulo="No hay pedidos para mostrar"
									mensaje="Cuando haya pedidos, se mostrarán aquí."
									icono="restaurant"
								/>
							</Card>
						)}
					</SoftBox>
					{/* <SoftBox p={2} mt={2}>
            <Card
              sx={{
                padding: 1,
                marginBottom: 2,
              }}
            >
              <SoftTypography variant="h6" align="center">
                Ordenes de trabajo
              </SoftTypography>
            </Card>
            {dataOrdenes?.ordenesTrabajo?.length > 0 ? (
              <DataTable columns={columnsOT} rows={rowsOT} xl />
            ) : (
              <Card>
                <SinDatos
                  titulo="No hay pedidos pendientes"
                  mensaje="Cuando haya pedidos pendientes, se mostrarán aquí."
                  icono="restaurant"
                />
              </Card>
            )}
          </SoftBox> */}
				</SoftBox>
				{/* <SoftBox display="flex" flexDirection="column" mt={2}>
          <Card
            sx={{
              padding: 1,
              marginBottom: 2,
            }}
          >
            <SoftTypography variant="h6" align="center">
              Menú del día
            </SoftTypography>
          </Card>
          {dataMenus?.reservadosHoy?.length > 0 ? (
            <DataTable columns={columnsMenu} rows={rowsMenu} />
          ) : (
            <Card>
              <SinDatos
                titulo="Sin menús reservados."
                mensaje="Sin datos para mostrar."
                icono="restaurant"
              />
            </Card>
          )}
        </SoftBox> */}
			</SoftBox>
		</PageLayout>
	);
};

export default Cocina;
